import React from "react";

const QuestionCard = ({
  questionData,
  questionNumber,
  totalQuestions,
  userAnswer,
  setUserAnswer,
  onNext,
  isTransitioning,
  timeLeft
}) => {
  const { type, question, options } = questionData;

  return (
    <div className={`glass-card ${isTransitioning ? "fade-out" : "fade-in"}`}>
      {/* Question counter */}
      <div className="question-count">
        Question {questionNumber} / {totalQuestions}
      </div>

      {/* Question type badge */}
      <div className={`question-type ${type}`}>
        {type === "single" && "Single Answer"}
        {type === "multi" && "Multiple Answers"}
        {type === "text" && "Fill in the Blank"}
      </div>

      {/* Question */}
      <div className="question-timer">
  ⏱️ {timeLeft}s
</div>

      <div className="question-text">{question}</div>

      {/* SINGLE ANSWER */}
      {type === "single" && (
        <div className="options">
          {options.map((option, index) => (
            <button
              key={index}
              className={`option-btn ${
                userAnswer[0] === index ? "selected" : ""
              }`}
              onClick={() => setUserAnswer([index])}
            >
              {userAnswer[0] === index && (
                <span className="checkmark">✓</span>
              )}
              {option}
            </button>
          ))}
        </div>
      )}

      {/* MULTIPLE ANSWER */}
      {type === "multi" && (
        <div className="options">
          {options.map((option, index) => (
            <button
              key={index}
              className={`option-btn ${
                userAnswer.includes(index) ? "selected" : ""
              }`}
              onClick={() =>
                setUserAnswer((prev) =>
                  prev.includes(index)
                    ? prev.filter((i) => i !== index)
                    : [...prev, index]
                )
              }
            >
              {userAnswer.includes(index) && (
                <span className="checkmark">✓</span>
              )}
              {option}
            </button>
          ))}
        </div>
      )}

      {/* FILL IN THE BLANK */}
      {type === "text" && (
        <>
          <p className="fill-hint">Type your answer below</p>
          <input
  className="text-input"
  type="text"
  placeholder="Your answer..."
  value={userAnswer[0] || ""}
  onChange={(e) => setUserAnswer([e.target.value])}
/>

        </>
      )}

      {/* Next button */}
      <button
        className="next-btn"
        onClick={onNext}
        disabled={userAnswer.length === 0}
      >
        Next
      </button>
    </div>
  );
};

export default QuestionCard;
